export class responseRemoveExpense {
    deleted:number;
    stats:any;
    constructor (data) {
        this.deleted = data.deleted;
        this.stats = data.stats;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-remove-expense.ts